// Selected election / resolution handed from Home to the voting pages.
// Items can carry base64 attachments + logo that exceed the ~5MB sessionStorage quota,
// so keep it in memory and persist to sessionStorage only when it fits.
let evotingData = null;

export const saveEvotingData = (data) => {
  evotingData = data;
  try {
    sessionStorage.setItem("evotingData", JSON.stringify(data));
  } catch (e) {
    // ponytail: too big to persist; works in-app, but refreshing the voting page loses it. Store an id and refetch if that matters.
    sessionStorage.removeItem("evotingData");
  }
};

export const readEvotingData = () =>
  evotingData ?? JSON.parse(sessionStorage.getItem("evotingData"));
